import React from "react";
import {BrowserRouter, Routes, Route, Link, NavLink} from "react-router-dom"
import Footer from "../components/Footer";
import { useLanguage } from '../i18n/translations';

export default function NotFound({categories}){
    const { translate } = useLanguage();
    return(
        <div className="w-full h-screen flex items-center justify-center">
            <div className="rounded sm:p-24 p-4 px-8 bg-bgSkin">
                <div className="w-full flex items-center justify-center"><img src="/images/logo.png" className="w-24" /></div>
                <h1 className="font-sans font-bold text-xl  sm:text-2xl text-center">{translate("Page Not Found")}</h1>
                <div className="w-full items-center justify-center flex mt-6">
                  <Link to="/" className="bg-brownSkin px-6 py-2 font-sans  text-white">{translate("Go to home")}</Link>
                </div>
            </div>


        </div>
    )
}